<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationdistance.header' | translate }} :</span>
        </h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdistance.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell">
              <div class="ir-form-group">
                <input type="text" class="ir-form-set" formControlName="label" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationdistance.distance' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="distance" />
                <div class="ir-line ir-select th-select" (click)="openDistancesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.distance.value && editForm.controls.distance.value >= 0
                        ? (editForm.controls.distance.value | distance)
                        : ('plugins.installationdistance.select-distance' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectDistancesMenu($event)" (modalClosed)="onClose($event)" #distancesModal></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
